// Copyright (c) 2016 Deere & Company

import Facets, {getDefaultState} from '../state/facets';
import actions from '../../actions-list';
import {getMatchingObjects} from '../../../shared/services/key-matcher';
import {updateList} from '../../../shared/services/list-selections';

const defaultPipTypeKeys = ['MALF', 'SAFT', 'FASF', 'OPT', 'PEP'];

const readPipTypes = (state, action) =>
    Facets.update(state, {
        pipTypesFacet: {
            $merge: {
                allowedTypes: action.data,
                isInitialLoad: false,
                selectedTypes: getMatchingObjects(defaultPipTypeKeys, action.data)
            }
        }
    });

const resetAllFacets = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            selectedDealers: {
                $set: action.dealerAccounts
            }
        },
        pipTypesFacet: {
            selectedTypes: {
                $set: getMatchingObjects(defaultPipTypeKeys, action.pipTypes)
            }
        }
    });

const toggleDealerAccountFacetItems = (state, action) => {

    const updatedSelectedDealers = state.dealerAccountsFacet.selectedDealers.length ?
        [] :
        action.allowedDealers;

    return Facets.update(state, {
        dealerAccountsFacet: {
            selectedDealers: {
                $set: updatedSelectedDealers
            }
        }
    });

};

const togglePipTypeFacetItems = (state, action) => {

    const updatedSelectedTypes = state.pipTypesFacet.selectedTypes.length ?
        [] :
        action.allowedTypes;

    return Facets.update(state, {
        pipTypesFacet: {
            selectedTypes: {
                $set: updatedSelectedTypes
            }
        }
    });

};

const updateDealerAccountFacetItem = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            selectedDealers: {
                $set: updateList(
                    action.dealerAccount,
                    action.isSelected,
                    'account',
                    state.dealerAccountsFacet.selectedDealers
                )
            }
        }
    });

const updatePipTypeFacetItem = (state, action) =>
    Facets.update(state, {
        pipTypesFacet: {
            selectedTypes: {
                $set: updateList(
                    action.pipType,
                    action.isSelected,
                    'key',
                    state.pipTypesFacet.selectedTypes
                )
            }
        }
    });

const updateDealerAccountItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            isInitialLoad: {$set: false},
            selectedDealers: {$set: action.allowedDealers}
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.READ_PIP_SEARCH_PIP_TYPES_SUCCESS]: readPipTypes,
        [actions.RESET_PIP_SEARCH_FILTERS]: resetAllFacets,
        [actions.TOGGLE_PIP_SEARCH_DEALER_ACCOUNT_FACET_ITEMS]: toggleDealerAccountFacetItems,
        [actions.TOGGLE_PIP_SEARCH_PIP_TYPE_FACET_ITEMS]: togglePipTypeFacetItems,
        [actions.UPDATE_PIP_SEARCH_DEALER_ACCOUNT_FACET_ITEM]: updateDealerAccountFacetItem,
        [actions.UPDATE_PIP_SEARCH_PIP_TYPE_FACET_ITEM]: updatePipTypeFacetItem,
        [actions.SELECT_ALL_PIP_SEARCH_DEALER_ACCOUNT_FACET_ITEMS]: updateDealerAccountItems
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/pip-search/reducers/facets.js